import React from "react";
import Empty from "assets/images/svg/empty_screen.svg";

const Info = ({ message = "", title = "Nothing Here Yet." }) => {
  return (
    <div className="noData">
      <img src={Empty} alt="Empty" />
      {title && <h2>{title}</h2>}
      <p>{message}</p>
    </div>
  );
};

export default Info;
